export const myAccountQuickLinks = [
  {
    id: 'PROFILE',
    title: 'Profile',
    icon: { icon: 'person-outline', pack: 'eva' },
    link: `accountSettings/profile`,
  },
  {
    id: 'PERSONAL_TOKEN',
    title: 'Personal Token',
    icon: { icon: 'key-outline', pack: 'fci' },
    link: 'accountSettings/tokens',
  },
  {
    id: 'PRIVACY_POLICY',
    title: 'Privacy Policy',
    icon: { icon: 'privacy-policy', pack: 'fci' },
  },
  {
    id: 'GITHUB_CREDS',
    title: 'Github Credentials',
    icon: { icon: 'github-outline', pack: 'eva' },
    link: 'accountSettings/credentials',
  },
  {
    id: 'LOGOUT',
    title: 'Logout',
    icon: { icon: 'log-out-outline', pack: 'fci' },
  },
];

export const helpCenterQuickLinks = [
  {
    title: 'Documentation',
    id: 'DOCS',
    icon: { icon: 'book-open-outline', pack: 'fci' },
    url: 'https://readme.facets.cloud/docs/what-is-facets-1',
    target: '_blank',
  },
  {
    title: 'Raise Ticket',
    id: 'RAISE_TICKET',
    icon: { icon: 'book-outline', pack: 'eva' },
  },
  {
    title: 'Join Community',
    id: 'COMMUNITY',
    icon: { icon: 'people-outline', pack: 'eva' },
    url: 'https://join.slack.com/t/facetscommunity/shared_invite/zt-29jnodnbk-aDGrEHVk8glCnUU5n_UWOg',
    target: '_blank',
  },
];
